import axios from 'axios'
import { buildRequestPrerequisites } from './dataService'

export const getIsVariationTrue = async ({ globalState, params }) => {
  const { headers, baseUrl, apiKey } = buildRequestPrerequisites({ globalState })

  const { userId, featureName, variableName } = params
  const url = `${baseUrl}/optimizely/userId/${userId}`
  try {
    const { data, status } = await axios({
      method: 'GET',
      url,
      headers,
      params: {
        api_key: apiKey,
        featureName,
        variableName
      }
    })
    return {
      data: data.data.variableValue,
      error: null,
      status
    }
  } catch (error) {
    return { data: null, error }
  }
}

export const getFeaturesVariables = async ({ globalState, params: { userId, featureNames } }) => {
  const { headers, baseUrl, apiKey } = buildRequestPrerequisites({ globalState })
  let url = `${baseUrl}/optimizely/userId/${userId}?`
  featureNames.forEach(featureName => (url = `${url}&featureNames=${featureName}`))
  try {
    const { data, status } = await axios({
      method: 'GET',
      url,
      headers,
      params: {
        api_key: apiKey
      }
    })
    return {
      data: data.data,
      error: null,
      status
    }
  } catch (error) {
    return { data: null, error }
  }
}

export const triggerCustomEvent = async ({ globalState, params: { userId, featureName, eventName } }) => {
  const { headers, baseUrl, apiKey } = buildRequestPrerequisites({ globalState })
  const url = `${baseUrl}/optimizely/userId/${userId}?`
  try {
    const { data, status } = await axios({
      method: 'GET',
      url,
      headers,
      params: {
        api_key: apiKey,
        featureName,
        eventName
      }
    })
    return {
      data: data.data,
      error: null,
      status
    }
  } catch (error) {
    return { data: null, error }
  }
}
